import React, { useEffect, useState } from "react";
import { StickyNote } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { ukDate } from "../lib/dates";

export const HandoverNoteDialog = ({ target, onClose, onSubmit }) => {
  const [note, setNote] = useState("");
  useEffect(() => { if (target) setNote(""); }, [target]);
  const list = target?.members || [];
  const who = list.length > 1 ? `${list.length} members` : list[0]?.name;
  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-[calc(100vw-2rem)] sm:max-w-lg" data-testid="handover-dialog">
        <DialogHeader>
          <DialogTitle>Hand {who} to Follow-up</DialogTitle>
          <DialogDescription>Add a short note so the Follow-up team knows the story{list.length > 1 ? " — it's shared by everyone you've selected" : ""}.</DialogDescription>
        </DialogHeader>
        <textarea data-testid="handover-note-input" rows={4} maxLength={500} value={note} onChange={(e) => setNote(e.target.value)}
          placeholder="e.g. Spoke twice, lovely family, keen on the Sunday kids' club. Prefers evening calls."
          className="w-full bg-[#EDF2F4] border border-[#EBE9E4] rounded-xl outline-none focus:ring-2 focus:ring-[#0B5E4E]/20 px-4 py-2.5 text-sm resize-none" />
        <div className="text-right text-[11px]" style={{ color: "var(--sj-text-3)" }}>{note.length}/500 · optional</div>
        <DialogFooter>
          <button data-testid="handover-cancel" onClick={onClose} className="rounded-full px-5 py-2 text-sm font-semibold border" style={{ borderColor: "var(--sj-border)" }}>Cancel</button>
          <button data-testid="handover-submit" onClick={() => onSubmit(note.trim())} className="rounded-full px-5 py-2 text-sm font-semibold text-white" style={{ background: "var(--sj-primary)" }}>Hand off</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const HandoverNote = ({ m }) => (
  <div data-testid={`handover-note-${m.id}`} className="mt-1.5 rounded-lg px-3 py-2 text-xs flex gap-2 max-w-xl" style={{ background: "#FEF6D8", color: "#5c4a00" }}>
    <StickyNote className="h-3.5 w-3.5 shrink-0 mt-0.5" style={{ color: "#8a6a00" }} />
    <span><strong>Handover note:</strong> {m.handover_note}
      <span className="block mt-0.5" style={{ color: "#8a6a00" }}>{m.handover_note_by}{m.handover_note_at ? ` · ${ukDate(m.handover_note_at)}` : ""}</span>
    </span>
  </div>
);
